import type { ProjectType } from 'src/data/project';

import { useMainActions } from '../../store';

export const useHandlers = () => {
  const mainActions = useMainActions();

  const handleChangeBlankProjectType = (newValue: ProjectType) => {
    mainActions.updateBlankProjectType(newValue);
  };

  const handleChangeImproveProjectType = (newValue: ProjectType) => {
    mainActions.updateImproveProjectType(newValue);
  };

  return {
    handleChangeBlankProjectType,
    handleChangeImproveProjectType,
  };
};
